/*--------------------------------------------------------------
# Custom scripts for testimonialCarouselSlider block
--------------------------------------------------------------*/

const testimonialCarouselSliders = document.querySelectorAll('.testimonial-carousel-slider');

for ( let i = 0; i < testimonialCarouselSliders.length; i++ ) {
    const sliderWrapper = testimonialCarouselSliders[i];
    const swiperEl      = sliderWrapper.querySelector('.swiper');
    const nextEl        = sliderWrapper.querySelector('.testimonial-carousel-swiper-next');
    const prevEl        = sliderWrapper.querySelector('.testimonial-carousel-swiper-prev');

    if ( ! swiperEl || ! nextEl || ! prevEl ) {
        continue;
    }

    // Add a unique index class so multiple instances don't cross-initialise.
    swiperEl.classList.add('swiper-' + i);
    nextEl.classList.add('testimonial-carousel-swiper-next-' + i);
    prevEl.classList.add('testimonial-carousel-swiper-prev-' + i);

    const carouselSection   = sliderWrapper.closest('.testimonial-carousel');
    const isImportCarousel  = carouselSection?.classList.contains('import-testimonial-carousel');
    const slideMatch        = carouselSection?.className.match(/\bslide--(\d+)\b/);
    let cardsPerView        = slideMatch ? parseInt(slideMatch[1], 10) : 1;

    if ( isImportCarousel ) {
        cardsPerView = 2;
    }
    const breakpoints     = {};

    if ( cardsPerView >= 2 ) {
        breakpoints[576] = {
            slidesPerView: 2,
            slidesPerGroup: 2,
        };
        breakpoints[992] = {
            spaceBetween: 48,
            slidesPerView: 2,
            slidesPerGroup: 2,
        };
    }

    if ( cardsPerView >= 3 ) {
        breakpoints[576] = {
            slidesPerView: 2,
            slidesPerGroup: 2,
        };
        breakpoints[992] = {
            spaceBetween: 48,
            slidesPerView: 3,
            slidesPerGroup: 3,
        };
    }

    if ( cardsPerView >= 4 ) {
        breakpoints[992] = {
            spaceBetween: 48,
            slidesPerView: 3,
            slidesPerGroup: 3,
        };
        breakpoints[1200] = {
            spaceBetween: 48,
            slidesPerView: 4,
            slidesPerGroup: 4,
        };
    }

    new Swiper(swiperEl, {
        grabCursor: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 24,
        navigation: {
            nextEl: '.testimonial-carousel-swiper-next-' + i,
            prevEl: '.testimonial-carousel-swiper-prev-' + i,
        },
        watchOverflow: true,
        breakpoints,
    });
}